<app-header [appTitle]=title></app-header>
@if (showLoginScreen) {
  <app-login-modal></app-login-modal>
}
@if (showImageCropper) {
  <app-profile-image-cropper></app-profile-image-cropper>
}
<div class="view-container">
  <router-outlet></router-outlet>
</div>
